import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IReport, Report } from "@/models/report.entity";

export const FleetDamageDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IReport, "vehicleId"> {
  protected mapEntity(entity: IReport): IReport {
    return new Report(entity);
  }

  getIdentifier(entity: IReport): string {
    return entity.id;
  }

  mapsConfig = {
    vehicleId: {
      getIdentifier: (entity: IReport) => (entity.vehicleId ? [entity.vehicleId] : [])
    }
  };
})();
